import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authApi } from '@/api/auth';
import { useAuth } from '@/auth/AuthContext';
import { clearDeepLink } from '@/auth/silentRefresh';
import { useCopy } from '@/hooks/useCopy';

export function NoAccess() {
  const { t } = useCopy();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await authApi.logout();
    } catch {
      /* logout errors are not blocking — clear the local session */
    }
    clearDeepLink();
    signOut();
    navigate('/auth/signed-out', { replace: true });
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Typography variant="h1" component="h1" gutterBottom>
          {t('auth.noAccessTitle', "You don't have access to this console")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t(
            'auth.noAccessBody',
            'Your account is signed in but has not been granted access to this product admin console. Contact your administrator if you believe this is a mistake.',
          )}
        </Typography>
        <Box>
          <Button
            variant="contained"
            onClick={() => {
              void handleSignOut();
            }}
          >
            {t('nav.signOut', 'Sign out')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
